import {
  FIELD_MODELS,
  PROJECT_PHASES,
  TRACKING_MODELS,
  TRACKING_BACKENDS,
  VIDEO_DEFAULT_TYPE,
} from '@/constants';

export const getDefaultState = () => {
  return {
    state: 0,
    options: {},
    linkedTvVideo: [],
    linkedVideo: [],
    activeCamera: null,
    defaults: {
      field_model_type: FIELD_MODELS[0].value,
      final_phase: PROJECT_PHASES[1].value,
      start: 0,
      end: -1,
      min_track_length: 50,
      field_length: 105,
      field_width: 68,
      phase: 0,
      tracking_model_type: TRACKING_MODELS[0].value,
      use_scaling_group: TRACKING_BACKENDS[0].value,
    },
    loading: false,
    type: VIDEO_DEFAULT_TYPE,
  }
};

export default getDefaultState();
